import { render, staticRenderFns } from "./ListLongRun.vue?vue&type=template&id=6e585d70&scoped=true&"
import script from "./ListLongRun.vue?vue&type=script&lang=js&"
export * from "./ListLongRun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e585d70",
  null
  
)

export default component.exports